import { ComponentType, type IFormilySchema } from '../types';

export const isFormComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.Form;

export const isArrayTableComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.FormArrayTable;

export const isFlowChartComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.FlowChart;

export const isTabPaneComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.TabPane;

export const isTabsComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.Tabs;

export const isTogglePanelsComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.TogglePanels;

export const isTogglePanelComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.TogglePanel;

export const isCollapseComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.Collapse;

export const isCollapsePanelComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.CollapsePanel;

export const isFormTabsComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.FormTabs;

export const isFormTabPaneComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.FormTabPane;

export const isCompareWorkspaceComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.CompareWorkspace;

export const isCompareWorkspacePanelComponent = (schema: any): boolean =>
  schema?.['x-component'] === ComponentType.CompareWorkspaceCustomPanel;

/**
 * Deprecated: not valid if multiple schema exists
 */
export const findFormComponent = (
  schema?: IFormilySchema
): IFormilySchema | null => {
  if (!schema?.properties) return null;

  for (const comp of Object.values(schema.properties)) {
    if (isFormComponent(comp)) return comp as unknown as IFormilySchema;
    const nested = findFormComponent(comp as unknown as IFormilySchema);
    if (nested) return nested;
  }

  return null;
};

const hasField = (schema: any, xDesignableId: string): boolean => {
  if (!schema?.properties) return false;
  for (const comp of Object.values<any>(schema.properties)) {
    if (comp['x-designable-id'] === xDesignableId) return true;
    if (hasField(comp, xDesignableId)) return true;
  }
  return false;
};

export const findFormComponenForField = (
  schema: IFormilySchema,
  xDesignableId: string
): IFormilySchema | null => {
  if (!schema?.properties) return null;

  for (const comp of Object.values(schema.properties)) {
    if (isFormComponent(comp) && hasField(comp, xDesignableId)) {
      return comp as unknown as IFormilySchema;
    }
    const nested = findFormComponenForField(
      comp as unknown as IFormilySchema,
      xDesignableId
    );
    if (nested) return nested;
  }

  return null;
};
